import { put, select, takeEvery } from "redux-saga/effects"
import { axiosPut, del, get, post } from "helpers/api_helper"
import {
  addCountdownClockFailed,
  addCountdownClockSuccess,
  deleteCountdownClockFailed,
  deleteCountdownClockSuccess,
  getCountdownClockFailed,
  getCountdownClockListFailed,
  getCountdownClockListSuccess,
  getCountdownClockSuccess,
  hideDeleteCountdownClockModal,
  updateCountdownClockFailed,
  updateCountdownClockOrderFailed,
  updateCountdownClockOrderSuccess,
  updateCountdownClockStatusFailed,
  updateCountdownCLockStatusSuccess,
  updateCountdownClockSuccess,
} from "./actions"
import {
  showSavingModal,
  hideSavingModal,
  setIsOutdated,
  putMenuItemSuccess,
  setSelectedFeature,
} from "../actions"
import {
  ADD_COUNTDOWN_CLOCK,
  DELETE_COUNTDOWN_CLOCK,
  GET_COUNTDOWN_CLOCK,
  GET_COUNTDOWN_CLOCK_LIST,
  UPDATE_COUNTDOWN_CLOCK,
  UPDATE_COUNTDOWN_CLOCK_ORDER,
  UPDATE_COUNTDOWN_CLOCK_STATUS,
} from "./actionTypes"

function* getCountdownClockList({ payload: { params } }) {
  try {
    const response = yield get("/countdown-clock", { params })
    const destroyed = yield select(state => state.CountdownClock.listDestroyed)
    if (!destroyed) {
      yield put(getCountdownClockListSuccess(response))
    }
  } catch (error) {
    yield put(getCountdownClockListFailed(error))
  }
}

function* addCountdownClock({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield post("/countdown-clock", params)
    if (params.menu_feature === 1) {
      const menuItem = yield axiosPut("/admin/menu-item", {
        entity_id: response.id,
        menu_item_id: response.menu_item_id,
      })
      yield put(putMenuItemSuccess(menuItem))
      yield put(setSelectedFeature(menuItem))
    }
    yield put(addCountdownClockSuccess(response))
    yield put(setIsOutdated(true))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(addCountdownClockFailed(error))
  }
}

function* getCountdownClock({ payload: { params } }) {
  try {
    const response = yield get(`/countdown-clock/${params}`)
    const destroyed = yield select(state => state.CountdownClock.destroyed)
    if (!destroyed) {
      yield put(getCountdownClockSuccess(response))
    }
  } catch (error) {
    yield put(getCountdownClockFailed(error))
  }
}

function* updateCountdownClock({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield axiosPut(`/countdown-clock/${params.id}`, params)
    yield put(updateCountdownClockSuccess(response))
    yield put(setIsOutdated(true))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateCountdownClockFailed(error))
  }
}

function* updateCountdownClockOrder({ payload: params }) {
  try {
    const response = yield axiosPut(`/countdown-clock/${params.id}`, params)
    yield put(updateCountdownClockOrderSuccess(response))
  } catch (error) {
    yield put(updateCountdownClockOrderFailed(error))
  }
}

function* updateCountdownClockStatus({ payload: params }) {
  try {
    const response = yield axiosPut(`/countdown-clock/${params.id}`, params)
    yield put(setIsOutdated(true))
    yield put(updateCountdownCLockStatusSuccess(response))
  } catch (error) {
    yield put(updateCountdownClockStatusFailed(error))
  }
}

function* deleteCountdownClock({ payload: params }) {
  try {
    const response = yield del(`/countdown-clock/${params.id}`, {
        menu_item_id: params.menu_item_id,
      },
    )
    yield put(deleteCountdownClockSuccess(response))
    yield put(hideDeleteCountdownClockModal())
  } catch (error) {
    yield put(deleteCountdownClockFailed(error))
  }
}

function* countdownClockSaga() {
  yield takeEvery(GET_COUNTDOWN_CLOCK_LIST, getCountdownClockList)
  yield takeEvery(ADD_COUNTDOWN_CLOCK, addCountdownClock)
  yield takeEvery(GET_COUNTDOWN_CLOCK, getCountdownClock)
  yield takeEvery(UPDATE_COUNTDOWN_CLOCK, updateCountdownClock)
  yield takeEvery(UPDATE_COUNTDOWN_CLOCK_STATUS, updateCountdownClockStatus)
  yield takeEvery(UPDATE_COUNTDOWN_CLOCK_ORDER, updateCountdownClockOrder)
  yield takeEvery(DELETE_COUNTDOWN_CLOCK, deleteCountdownClock)
}

export default countdownClockSaga
